import type { StateTree } from '@makemydeal/dr-dash-types';
import { getCreditAppReferenceId } from './creditAppSelectors';
import { getAutoLeadId, getEcommerceOrderNumber, getTenantId } from './dealXgDetailsSelectors';
import { getCurrentOfferType, getDealXgId, getDealXgVersion, getGlobalCustomerId } from './offerRedux';
import { getApplicationName, getDealRefId, getOfferCommonConsumerId, getOfferGlobalCustomerId } from './offerSelectors';

export const createLoggingContextSelector = (state: StateTree) => {
    return {
        dealRefId: getDealRefId(state),
        dealXgId: getDealXgId(state),
        dealXgVersion: getDealXgVersion(state),
        globalCustomerId: getGlobalCustomerId(state) || getOfferGlobalCustomerId(state),
        commonConsumerId: getOfferCommonConsumerId(state),
        tenantId: getTenantId(state),
        autoLeadId: getAutoLeadId(state),
        creditAppReferenceId: getCreditAppReferenceId(state),
        currentOfferType: getCurrentOfferType(state),
        applicationName: getApplicationName(state),
        omsOrderNumber: getEcommerceOrderNumber(state)
    };
};
